import HR from './HR'
import OB from './OB'
import SP from './SP'

export default [
    OB,
    SP,
    HR
]